export default __webpack_public_path__ + "static/media/3.509b1bcf.webp";